
export enum ShipperPhoneCountryCd {
	CANADA = 'Canada',
	MEXICO = 'Mexico',
	UNDEFINED = 'Undefined',
	UNITED_STATES = 'United States',
	US = 'US'}

